import { render, staticRenderFns } from "./PostcodeProductMix.vue?vue&type=template&id=1da5f791&scoped=true&"
import script from "./PostcodeProductMix.vue?vue&type=script&lang=ts&"
export * from "./PostcodeProductMix.vue?vue&type=script&lang=ts&"
import style0 from "./PostcodeProductMix.vue?vue&type=style&index=0&id=1da5f791&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da5f791",
  null
  
)

export default component.exports